import { useTranslation } from 'next-i18next';

import Heading from '@components/ui/Heading';
import Table from '@components/ui/Table';
import * as Accordion from '@components/ui/Accordion';
import { MecProduct } from '@adapters/bigcommerce/types/product';

import styles from './ProductStorePC.module.scss';

interface ProductStorePCProps {
  productNotes: MecProduct['productNotes'];
}

const ProductStorePC = ({ productNotes }: ProductStorePCProps) => {
  const { t } = useTranslation(['pdp']);

  return (
    <Accordion.Container isOpen>
      <Accordion.Title>
        <Heading
          semanticLevel="h2"
          styleLevel="4"
          className={styles.productInfoAccordionHeading}
        >
          {t('product.notes')}
        </Heading>
      </Accordion.Title>
      <Accordion.Collapsible>
        {productNotes && (
          <Table
            classNames={styles.productNotesHeading}
            dataRows={Object.entries(productNotes).map((key) => [
              <strong>{key[0].replace(/([A-Z])/g, ' $1').trim()}</strong>,
              <span dangerouslySetInnerHTML={{ __html: key[1] }} />,
            ])}
          />
        )}
      </Accordion.Collapsible>
    </Accordion.Container>
  );
};

export default ProductStorePC;
